/* eslint-disable react/jsx-filename-extension */

import React from 'react';

import EcommerceLayout from './src/components/EcommerceLayout';

function preferDefault(module) {
  return (module && module.default) || module;
}

function isCannotFindModuleError(error) {
  return error.toString().indexOf('Error: Cannot find module') !== -1;
}

function isCheckoutPath(pathToCheck) {
  return pathToCheck.includes('/checkout/');
}

function isOrderConfirmedPath(pathToCheck) {
  return pathToCheck.includes('/order-confirmation/');
}

let Layout;

try {
  // eslint-disable-next-line import/no-dynamic-require, global-require, no-undef
  Layout = preferDefault(require(CHECKOUT_LAYOUT_COMPONENT_PATH));
} catch (e) {
  if (isCannotFindModuleError(e)) {
    // eslint-disable-next-line no-undef
    throw new Error(`Couldn't find layout component at "${CHECKOUT_LAYOUT_COMPONENT_PATH}".`);
  }
}

export function wrapPage({ element, props }) {
  const { location = {} } = props;
  const { pathname = '' } = location;
  let finalElement = element;

  if (isCheckoutPath(pathname) || isOrderConfirmedPath(pathname)) {
    finalElement = <Layout>{element}</Layout>;
  }

  return <EcommerceLayout {...props}>{finalElement}</EcommerceLayout>;
}
